import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { refreshRed } from "@/lib/red";
import { fmtDay } from "@/lib/solicitudes";

export default function NotificacionesPage() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/red/avisos").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const open = async (n) => {
    if (!n.leida) await api.post(`/red/avisos/${n.id}/leer`).catch(() => {});
    refreshRed();
    if (n.url) nav(n.url); else load();
  };
  const readAll = async () => { await api.post("/red/avisos/leer").catch(() => {}); refreshRed(); load(); };
  if (!d) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div>;
  return (
    <div data-testid="notificaciones-page" className="space-y-3">
      <div className="flex items-center justify-between">
        <p data-testid="notif-unread-count" className="text-sm c-text-2">{d.sin_leer ? `${d.sin_leer} sin leer` : "Todo leído"}</p>
        {d.sin_leer > 0 && <button data-testid="notif-read-all-btn" onClick={readAll} className="text-xs font-semibold c-accent flex items-center gap-1"><CheckCheck className="w-4 h-4" /> Marcar todas como leídas</button>}
      </div>
      {d.items.length === 0 ? <p data-testid="notif-empty" className="c-card p-6 text-center text-sm c-text-2">Sin notificaciones todavía.</p> : (
        <ul className="c-card divide-y c-line overflow-hidden">
          {d.items.map((n) => (
            <li key={n.id}>
              <button data-testid="notif-item" onClick={() => open(n)} className={`w-full text-left p-3.5 flex items-start gap-3 transition-colors ${n.leida ? "" : "bg-[#bc9538]/10"}`}>
                <Bell className={`w-4 h-4 mt-0.5 shrink-0 ${n.leida ? "c-muted" : "c-accent"}`} />
                <span className="flex-1 min-w-0"><span className={`block text-sm ${n.leida ? "c-text-2" : "font-semibold"}`}>{n.texto}</span><span className="text-[11px] c-muted">{fmtDay(n.created_at)}</span></span>
                {!n.leida && <span className="w-2 h-2 rounded-full bg-[#dc2626] mt-1.5" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
